import { APP_INITIALIZER, importProvidersFrom, inject } from '@angular/core';
import {
	provideTransloco as _provideTransloco,
	TRANSLOCO_LOADER,
	TranslocoModule,
	TranslocoService,
} from '@ngneat/transloco';
import { LANGUAGES } from 'app/config/language.constants';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

export const provideTransloco = (): Array<any> => {
	return [
		importProvidersFrom(TranslocoModule),
		_provideTransloco({
			config: {
				availableLangs: LANGUAGES,
				defaultLang: 'pt-br',
				fallbackLang: 'pt-br',
				reRenderOnLangChange: true,
				prodMode: true,
			},
			loader: TranslocoHttpLoader,
		}),
		{
			// Provide the default Transloco loader
			provide: TRANSLOCO_LOADER,
			useClass: TranslocoHttpLoader,
		},
		{
			// Preload the default language before the app starts to prevent empty/jumping content
			provide: APP_INITIALIZER,
			useFactory: () => {
				const translocoService = inject(TranslocoService);
				const defaultLang = translocoService.getDefaultLang();
				translocoService.setActiveLang(defaultLang);
				return () => translocoService.load(defaultLang).toPromise();
			},
			multi: true,
		},
	];
};
